import { use_slice_generation } from '@/hooks/store/use_slices';
import { assert_instanceof } from '@shared/asserts/utils_asserts';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { FIELD_PRIMITIVE__base } from '@shared/dto/generation/graph_invoke/_fields/_primitives/_base/FIELD_PRIMITIVE__base';
import { useMemo } from 'react';

export function G_HOOK__graph_field_hashed_for_hover(field: FIELD__base) {
  const { generation_current } = use_slice_generation(['generation_current']);

  let out = useMemo(() => get_field_hashed(), [field, generation_current]);

  function get_field_hashed() {
    if (field.is_stub()) return FIELD__base.CREATE_STUB();
    if (!generation_current.tool.graph.meta.errors.is_empty()) return FIELD__base.CREATE_STUB();

    field = field.clone();

    let graph_clone = generation_current.tool.graph.clone();

    field.hash__clear(graph_clone);
    field.validate(graph_clone);
    field.hash__update_with_graph(graph_clone);

    graph_clone.field__replace(field);

    let out = graph_clone.field__get_by_id(field.meta.field_id);
    assert_instanceof(out, FIELD_PRIMITIVE__base);

    return out;
  }

  return out;
}
